import constant from "@/utils/constant";
import { HttpClient } from "@narisolutions/api-client";
import { auth } from "./firebase";

const api = new HttpClient({ baseURL: constant.VITE_API_URL + "/admin", authInstance: auth });

export default api;
